module.exports = __webpack_public_path__ + "static/media/tiffanie.ed161f75.jpg";